import React from 'react';
import PropTypes from 'prop-types';
import './PageHeader.css';

function PageHeader({ title, subtitle }) {
  return (
    <div className="page-header rounded-3 p-4 text-white mb-4">
      <h2 className="fw-bold mb-2">{title}</h2>
      {subtitle && <p className="mb-0 opacity-90">{subtitle}</p>}
    </div>
  );
}

PageHeader.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string
};

export default PageHeader;
